<gcp-workspace-error-state
  heading="403 — Access Denied"
  message="You do not have permission to view this page."
>
  <button mat-raised-button color="primary" (click)="goToHome()">
    Go back to Home
  </button>
</gcp-workspace-error-state>
